import { ComponentType } from 'react'
import { SvgIconProps } from '@mui/material/SvgIcon'
import HomeIcon from '@mui/icons-material/Home'
import MailIcon from '@mui/icons-material/Mail'
import AssessmentIcon from '@mui/icons-material/Assessment'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import GroupIcon from '@mui/icons-material/Group'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import HistoryIcon from '@mui/icons-material/History'
import { hasReportsAccess } from '../utils'

export type NavItem = {
  label: string
  to: string
  icon: ComponentType<SvgIconProps>
  badge?: number
}

// Mirrors the visibility rules from the old Header.tsx exactly (desktop and
// mobile branches there were identical, just rendered differently).
export const getMainNavItems = (
  authUser: any,
  budgetAccessLevel?: string,
  inboxCount?: number,
): NavItem[] => {
  const items: NavItem[] = [
    { label: 'Dashboard', to: '/panel', icon: HomeIcon },
    { label: 'Inbox', to: '/panel/inbox', icon: MailIcon, badge: inboxCount },
    { label: 'Vouchers', to: '/panel/vouchers', icon: DescriptionOutlinedIcon },
  ]

  if (
    hasReportsAccess(
      authUser.branch,
      authUser.department?.name,
      authUser.user_role?.code,
    )
  ) {
    items.push({ label: 'Reports', to: '/panel/reports', icon: AssessmentIcon })
  }

  if (authUser.branch === 'NATIONAL') {
    items.push({
      label: 'Budget vs Actual',
      to: '/panel/budget-report',
      icon: AccountBalanceIcon,
    })
  }

  if (budgetAccessLevel === 'ALL') {
    items.push({ label: 'Budgets', to: '/panel/budgets', icon: RequestQuoteIcon })
  }

  if (
    authUser.branch === 'NATIONAL' &&
    authUser.user_role?.code === 'AMIN_NATIONAL'
  ) {
    items.push({
      label: 'Export Vouchers',
      to: '/panel/export',
      icon: FileDownloadIcon,
    })
  }

  return items
}

export const getAdminNavItems = (authUser: any): NavItem[] => {
  if (!authUser.site_admin) return []
  return [
    { label: 'Users', to: '/admin/users', icon: GroupIcon },
    { label: 'Roles', to: '/admin/roles', icon: AdminPanelSettingsIcon },
    { label: 'Workflows', to: '/admin/workflows', icon: AccountTreeIcon },
    { label: 'Vouchers', to: '/admin/vouchers', icon: ReceiptLongIcon },
    { label: 'Activities', to: '/admin/activities', icon: HistoryIcon },
  ]
}
